/* eslint-disable camelcase */
/* eslint-disable react/display-name */
/**
 * @file AlbuminuriaF13View.jsx
 * @author Fernando Ruano
 * @description AlbuminuriaF13 View Page
 */

// Dependencies
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';

// Commons
import styleGuideColors from 'commons/styleGuideColors';

// Components
import DashboardCard from 'components/DashboardCard';
import DashboardDoughnut from 'components/Charts/DashboardDoughnut';
import useTruncateAndFormat from 'hook/useTruncateAndFormat';

/**
 * AlbuminuriaF13 View
 * @param { Object } dashboardStaffActions - DashboardStaff Actions.
 * @return { Node } React node.
 */

function AlbuminuriaF13View({ dashboardStaffActions, clinicId }) {
  const { t: translate } = useTranslation();
  const history = useHistory();
  const [chartData, setChartData] = useState(null);

  const { getAlbuminuriaF13 } = dashboardStaffActions;

  const onGetData = (_, resp) => {
    if (resp?.data) {
      const colors = [
        styleGuideColors.baxterBrandTeal,
        styleGuideColors.baxterBrandBaxterBlue,
        styleGuideColors.baxterBrandOrange
      ];
      const dataObject = resp?.data?.map((itm, idx) => ({
        value: useTruncateAndFormat(itm.porcentaje, 2),
        label: itm.albuminuria,
        color: colors[idx],
        cuantos: itm.cuantos
      }));
      setChartData(dataObject);
    } else {
      setChartData([]);
    }
  };

  useEffect(() => {
    getAlbuminuriaF13({ clinicId }, onGetData);
  }, [clinicId, translate]);

  const handleDetailClick = (index) => {
    const shift = chartData[index].label;
    const totalItems = chartData[index].cuantos;
    history.push(`/main/dashboard-detail/albuminuria/${shift}/${totalItems}`);
  };

  return (
    <DashboardCard id="F13" loading={!chartData}>
      <DashboardDoughnut
        title={translate('Albuminuria')}
        dataValues={chartData}
        onDetailClick={handleDetailClick}
      />
    </DashboardCard>
  );
}

/**
 * Component definition of proptypes.
 */
AlbuminuriaF13View.propTypes = {
  dashboardStaffActions: PropTypes.shape({
    getAlbuminuriaF13: PropTypes.func.isRequired
  }),
  clinicId: PropTypes.any
};

export default AlbuminuriaF13View;
